import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		container: {
			[theme.breakpoints.up("xs")]: {
				height: "auto",
			},
			[theme.breakpoints.down("xs")]: {
				height: "100%",
			},
		},
		closeButton: {
			position: "absolute",
			right: theme.spacing(1),
			top: theme.spacing(1),
			color: theme.palette.grey[500],
		},
		actions: {
			justifyContent: "left",
			paddingLeft: 24,
		},
		action: {
			marginRight: 10,
			fontSize: 16,
		},
		actionIcon: {
			marginRight: 4,
			fontSize: 16,
			fontFamily: "monospace",
			fontWeight: "bold",
		},
	} satisfies Record<string, CSSObject>);
};
